import { useV2ListNotesQuery } from "@generated";
import { Note } from "../types/Note";

interface UseListNotesArgs {
  projectId: number;
  page?: { number?: number; size?: number };
}

const useListNotes = ({ projectId, page }: UseListNotesArgs) => {
  const { data, error, isLoading, isFetching, refetch } = useV2ListNotesQuery({
    projectId: String(projectId),
    page,
    //@ts-ignore
    include: ["project.project-services.project-phase"],
  });

  const included: any[] = data?.included || [];

  const findIncluded = (type: string, id: string) =>
    included.find((i) => i.type === type && String(i.id) === String(id));

  const notes: Note[] =
    data?.data?.map((note: any) => {
      const notable = note.attributes?.notable;
      let projectService: Note["projectService"];

      if (
        notable?.["notable-type"] === "project_services" &&
        notable?.["notable-id"]
      ) {
        const service = findIncluded(
          "project-services",
          String(notable["notable-id"])
        );
        if (service) {
          const phaseId = service.relationships?.["project-phase"]?.data?.id;
          const phase = phaseId
            ? findIncluded("project-phases", String(phaseId))
            : null;
          projectService = {
            id: String(service.id),
            name: service.attributes?.name || "",
            serviceType: service.attributes?.["service-type"] || "",
            phase: phase?.attributes?.name || undefined,
          };
        }
      }

      return {
        id: String(note.id),
        name: note.attributes?.name || "",
        content: note.attributes?.content || "",
        username: note.attributes?.username || "",
        createdAt: note.attributes?.["created-at"] || "",
        editable: note.attributes?.editable ?? false,
        projectService,
      };
    }) || [];

  const pageMeta = {
    pageCount: data?.meta?.["page-count"] || 1,
    recordCount: data?.meta?.["record-count"] || 0,
  };

  return {
    notes,
    notesError: error,
    notesLoading: isLoading,
    notesFetching: isFetching,
    pageMeta,
    refetch,
  };
};

export default useListNotes;
